import React from 'react';
import classNames from 'classnames';

const MenuItem = (props) => {
  const itemClasses = classNames({
    [props.className]: true,
    [`${props.className}_active`]: props.config.active
  });

  return (
    <li className={itemClasses}>
      <a href="" className="menu__link">
        { props.config.title }
      </a>
    </li>
  )
};

export default MenuItem;


// WEBPACK FOOTER //
// ./src/components/MenuItem/MenuItem.js